require('es6-promise').polyfill(); // required for IE
import Vue from 'vue'
import Vuex from 'vuex'

import actions from './_actions'
import mutations from './_mutations'

import profile from './profile'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        appState: {},
        countries: [],
        comboDateConfigs: {
            format: "YYYY-MM-DD HH:mm:ss",
            template: "D MMM YYYY",
            maxYear: new Date().getFullYear() - 1,
            minYear: new Date().getFullYear() - 100,
        }
    },
    getters: {
        App: state => state.appState,
        authUser: (state, getters) => getters.App.user,
        countries: state => state.countries,
    },
    actions,
    mutations,
    modules: {
        profile
    }
});


// WEBPACK FOOTER //
// ./src/store/index.js